import request from '@/service/index'
import qs from 'qs'

// 获取消费明细列表
export const getPayList = (params: any) => {
  return request({
    url: '/fundsHistory/getList',
    method: 'GET',
    params
  })
}

export const deleteHistory = (params: any) => {
  return request({
    url: '/fundsHistory/delete',
    method: 'GET',
    params
  })
}

// 金币充值
export const submitCharge = (data: any) => {
  return request({
    url: '/fundsHistory/addFunds',
    method: 'POST',
    data: qs.stringify(data)
  })
}

export const withholdCharge = (data: any) => {
  return request({
    url: '/fundsHistory/deFunds',
    method: 'POST',
    data: qs.stringify(data)
  })
}

export const getBalanceList = (params: any) => {
  return request({
    url: '/fundsHistory/getBalanceList',
    method: 'GET',
    params
  })
}

export const getCurrentUserBill = () => {
  return request({
    url: '/fundsHistory/getBalance',
    method: 'GET'
  })
}

// 编辑用户接口
export const editUserInfo = (data: any) => {
  return request({
    url: '/user/save',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 获取用户角色列表
export const getRoleList = () => {
  return request({
    url: '/user/getRoleList',
    method: 'GET'
  })
}

// 获取日志列表
export const getLogList = (params: any) => {
  return request({
    url: '/user/getLogList',
    method: 'GET',
    params
  })
}

// 保存用户角色
export const saveUserRole = (data: any) => {
  return request({
    url: '/user/saveRole',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 获取规则列表
export const getRuleList = (params: any) => {
    return request({
        url: '/autoCharge/getRuleList',
        method: 'GET',
        params
    })
}
// 获取充值订单列表
export const getChargeList = (params: any) => {
    return request({
        url: '/autoCharge/getList',
        method: 'GET',
        params
    })
}


// 编辑规则
export const editChargeRule = (data: any) => {
    return request({
        url: '/autoCharge/saveChargeRule',
        method: 'POST',
        data: qs.stringify(data)
    })
}
export const deleteChargeOrder = (params: any) => {
    return request({
        url: '/autoCharge/deleteChargeOrder',
        method: 'POST',
        params
    })
}
export const deleteChargeRule = (params: any) => {
    return request({
        url: '/autoCharge/deleteChargeRule',
        method: 'POST',
        params
    })
}
